// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vtable-page[data-v-14568762] {
  padding: 12px 16px;
  background-color: #f5f7fa;
  min-height: 100vh;
}
.page-container[data-v-14568762] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
.page-container .left[data-v-14568762] {
  width: 100%;
  height: 100%;
}
.page-container .right[data-v-14568762] {
  width: 100%;
  flex: 1;
  height: 100%;
  overflow: hidden;
}
.bill-setting[data-v-14568762] {
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/BillSettings/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;ACAF;ADGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;ACDF;ADJA;EAQI,WAAA;EACA,YAAA;ACDJ;ADRA;EAaI,WAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;ACFJ;ADMA;EACE,YAAA;EACA,WAAA;ACJF","sourcesContent":["\n.vtable-page {\n  padding: 12px 16px;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n\n.page-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  .left {\n    width: 100%;\n    height: 100%;\n  }\n\n  .right {\n    width: 100%;\n    flex: 1;\n    height: 100%;\n    overflow: hidden;\n  }\n}\n\n.bill-setting {\n  height: 100%;\n  width: 100%;\n}\n",".vtable-page {\n  padding: 12px 16px;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n.page-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.page-container .left {\n  width: 100%;\n  height: 100%;\n}\n.page-container .right {\n  width: 100%;\n  flex: 1;\n  height: 100%;\n  overflow: hidden;\n}\n.bill-setting {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
